module.exports = __webpack_public_path__ + "img/symbol_10.88b79a82.png";